// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"QS","backgroundimage":"RS","header":"SS","headerwrap":"TS","title":"US","promomessage":"VS","upsellItem":"WS","upsellImg":"XS","helperText":"YS","upsellHeadline":"ZS","price":"aT","upsellGross":"bT","upsellNet":"cT","upsellButton":"eT","nutritionfacts":"fT","nutritionimg":"gT","containerwhy":"hT","nutritionwrappwer":"iT","headlinewhy":"jT","boxwhy":"kT","textwhy":"lT","backbutton":"mT","drawercontainer":"nT","logoheader":"oT","textwrap":"pT","timer":"qT"};
    if(module.hot) {
      // 1738064243604
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  